<template>
  <div class="promotion-chart" v-if="rounds.length > 0">
    <div class="tabs">
      <div v-for="(item, i) in rounds" :key="i" class="item" :class="{ 'choose': i === current }"
        @click="changeRounds(i)">
        <span v-if="item.alias">{{ item.alias }}</span>
        <span v-else>第{{ i + 1 }}轮</span>
      </div>
    </div>
    <div class="games" :style="{ 'padding-top': current === 0 ? '24px' : '45px' }">
      <div class="game" :class="[getClass(game.isChampionGame), getLeft ? 'marginLeft' : '']"
        v-for="(game, index) in getIndexList" :key="index">
        <div class="left" v-if="current > 0 && game.id">
          <div class="prev-games">
            <div class="base top">
              <div class="logo">
                <img :src="getImg(game.homeTeam.id).homeBadge" v-if="getImg(game.homeTeam.id).isTeam"
                  style="width: 20px;height: 20px;" />
                <div style="width: 20px;height: 20px;text-align: center;line-height: 20px;">轮</div>
              </div>
              <div class="logo" style="margin-top: 19px">
                <img :src="getImg(game.homeTeam.id).awayBadge" v-if="getImg(game.homeTeam.id).isTeam"
                  style="width: 20px;height: 20px;" />
                <div style="width: 20px;height: 20px;text-align: center;line-height: 20px;">空</div>
              </div>
            </div>
            <div class="base bottom">
              <div class="logo">
                <img :src="getImg(game.awayTeam.id).homeBadge" v-if="getImg(game.awayTeam.id).isTeam"
                  style="width: 20px;height: 20px;" />
                <div style="width: 20px;height: 20px;text-align: center;line-height: 20px;">轮</div>
              </div>
              <div class="logo" style="margin-top: 19px">
                <img :src="getImg(game.awayTeam.id).awayBadge" v-if="getImg(game.awayTeam.id).isTeam"
                  style="width: 20px;height: 20px;" />
                <div style="width: 20px;height: 20px;text-align: center;line-height: 20px;">空</div>
              </div>
            </div>
          </div>
          <div class="line size-left">
            <div class="line1"></div>
            <div class="line2"></div>
            <div class="line3"></div>
            <div class="line4"></div>
          </div>
        </div>
        <div class="teams" :style="{ 'background-color': current === (rounds.length - 1) ? '#FFF6F1' : '#F9FAFC' }">
          <div class="time">{{ setDate(game.beginDate) }}</div>
          <div class="team">
            <div style="display: flex; flex-flow: row;align-items: center;">
              <img :src="filterImage(game.homeTeam.badge, 18, 18)" style="width: 20px;height: 20px;"
                v-if="game.homeTeam.badge">
              <van-icon name="user-o" v-else size="20px" color="#000" />
              <div style="margin-left: 12px;line-height: 20px;"
                :style="{ color: game.homeScore > game.awayScore ? (current < (rounds.length - 1) ? '#191919' : '#FA6405') : '#8C8C8C' }">
                {{ game.homeTeam.name }}
              </div>
              <img
                v-if="current === (rounds.length - 1) && game.homeScore && game.homeScore > game.awayScore && (game.isChampionGame === 1 || game.isChampionGame === 2)"
                :src="game.isChampionGame === 1 ? 'https://images.snsports.cn//Frdbt90ndpcKQBuo4LHXtoqJNfeU' : 'https://images.snsports.cn/FjBNjYLjHA7ulHAAr1GHH5YhcFPs'"
                style="width: 21px;height: 23px;" />
            </div>
            <div
              :style="{ 'font-weight': game.homeScore > game.awayScore ? 500 : 'normal', color: game.homeScore > game.awayScore ? (current < (rounds.length - 1) ? '#191919' : '#FA6405') : '#8C8C8C' }">
              {{ game.homeScore >= 0 ? game.homeScore : '-' }}
            </div>
          </div>
          <div class="team">
            <div style="display: flex; flex-flow: row;">
              <img :src="filterImage(game.awayTeam.badge, 18, 18)" style="width: 20px;height: 20px;"
                v-if="game.homeTeam.badge">
              <van-icon name="user-o" v-else size="20px" color="#000" />
              <div style="margin-left: 12px;line-height: 20px;"
                :style="{ color: game.awayScore > game.homeScore ? (current < (rounds.length - 1) ? '#191919' : '#FA6405') : '#8C8C8C' }">
                {{ game.awayTeam.name }}
              </div>
              <img
                v-if="current === (rounds.length - 1) && game.awayScore && game.awayScore > game.homeScore && (game.isChampionGame === 1 || game.isChampionGame === 2)"
                :src="game.isChampionGame === 1 ? 'https://images.snsports.cn//Frdbt90ndpcKQBuo4LHXtoqJNfeU' : 'https://images.snsports.cn/FjBNjYLjHA7ulHAAr1GHH5YhcFPs'"
                style="width: 21px;height: 23px;" />
            </div>
            <div
              :style="{ 'font-weight': game.awayScore > game.homeScore ? 500 : 'normal', color: game.awayScore > game.homeScore ? (current < (rounds.length - 1) ? '#191919' : '#FA6405') : '#8C8C8C' }">
              {{ game.awayScore >= 0 ? game.awayScore : '-' }}
            </div>
          </div>
        </div>
        <div class="right" :style="{ 'top': current === 0 ? '-85px' : '-150px' }"
          v-if="current < rounds.length - 1 && (index + 1) % 2 === 0">
          <div class="line size-right" :class="current > 0 ? 'height' : ''">
            <div class="line1"></div>
            <div class="line2"></div>
            <div class="line3"></div>
            <div class="line4"></div>
          </div>
          <div class="next">
            <div class="logo">
              <div v-if="hasBadge(current + 1, parseInt(index / 2 + ''), 'homeTeam')">
                <img :src="filterImage(rounds[current + 1].games[parseInt(index / 2 + '')].homeTeam.badge)"
                  style="width: 20px;height: 20px;" />
              </div>
              <van-icon name="user-o" v-else size="20px" color="#000" />
            </div>
            <div class="logo" style="margin-top: 19px">
              <div v-if="hasBadge(current + 1, parseInt(index / 2 + ''), 'awayTeam')">
                <img :src="filterImage(rounds[current + 1].games[parseInt(index / 2 + '')].awayTeam.badge)"
                  style="width: 20px;height: 20px;" />
              </div>
              <van-icon name="user-o" v-else size="20px" color="#000" />
            </div>
          </div>
        </div>
        <div class="right-gj" v-if="game.isChampionGame === 1 || game.isChampionGame === 2 && false">
          <div class="line-gj"></div>
          <img src="https://images.snsports.cn/FpGLDAoFtDfHq95dlHYaPRYceoXI" v-if="game.isChampionGame === 1">
          <img src="https://images.snsports.cn/FjBNjYLjHA7ulHAAr1GHH5YhcFPs" v-else>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateUtil, QNImageUtil } from '@/utils'
export default {
  props: {
    rounds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current: 0
    }
  },
  computed: {
    getIndexList() {
      const list = this.rounds[this.current].games
      return list
    },
    getLeft() {
      let bol = this.current !== 0
      if (bol) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    getClass(isChampionGame) {
      this.current // 当前轮次
      this.rounds.length // 总轮次长度
      if (this.current === 0 && this.rounds.length > 1) return 'w1'
      else if ((this.current === (this.rounds.length - 1)) && isChampionGame !== 0) return 'w3' // 冠军
      else if ((this.current === (this.rounds.length - 1))) return 'w3'
      else return 'w2'
    },
    hasBadge(i, j, type) {
      if (this.rounds.length <= i) return false
      else if (this.rounds[i].games.length <= j) return false
      else return this.rounds[i].games[j][type] && this.rounds[i].games[j][type].badge && this.rounds[i].games[j][type].badge.length > 0
    },
    changeRounds(index) {
      this.current = index
      this.$forceUpdate()
    },
    setDate(value) {
      return DateUtil.parseDateTime(value, '{y}-{m}-{d}')
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    getImg(id) {
      // 解析：1. this.rounds 总轮次包含每轮次的比赛列表
      //      2. this.current 当前轮次
      const games = this.rounds[this.current - 1].games // 当前论次的上一轮次比赛列表
      const game = games.find(item => { // 找到上一轮这个队伍的比赛
        return item.homeTeam.id === id || item.awayTeam.id === id
      })
      let obj = {
        isTeam: false
      }
      if (game) {
        obj.homeBadge = this.filterImage(game.homeTeam.badge, 18, 18)
        obj.awayBadge = this.filterImage(game.awayTeam.badge, 18, 18)
        obj.isTeam = true
      }
      return obj
    }
    // getImg(index, type, name) {
    //   const games = this.rounds[this.current - 1].games
    //   if (type === 1) {
    //     if (name === 'home') {
    //       return games[index * 2] && games[index * 2].homeTeam.badge ? this.filterImage(games[index * 2].homeTeam.badge, 18, 18): false
    //     } else {
    //       return games[index * 2] && games[index * 2].awayTeam.badge ? this.filterImage(games[index * 2].awayTeam.badge, 18, 18) : false
    //     }
    //   } else if (type === 2) {
    //     if (name === 'home') {
    //       return games[index * 2 + 1] && games[index * 2 + 1].homeTeam.badge ? this.filterImage(games[index * 2 + 1].homeTeam.badge, 18, 18) : false
    //     } else {
    //       return games[index * 2 + 1] && games[index * 2 + 1].awayTeam.badge ? this.filterImage(games[index * 2 + 1].awayTeam.badge, 18, 18) : false
    //     }
    //   }
    // }
  },
};
</script>

<style scoped lang="scss">
.promotion-chart {
  padding: 16px;

  .tabs {
    display: flex;
    overflow: scroll;
    margin-bottom: 10px;

    .item {
      width: 80px;
      min-width: 80px;
      height: 28px;
      line-height: 28px;
      margin-right: 11px;
      border-radius: 14px;
      text-align: center;
      color: #282828;
      background-color: #F3F3F3;
      font-size: 13px;
    }

    .choose {
      background-color: #191919;
      color: #FFFFFF;
    }
  }

  .games {
    padding-top: 24px;
    margin: 0 12px;

    .game {
      border-radius: 2px;
      border: 1px #E7E7EF solid;
      position: relative;

      .teams {
        position: relative;
        // height: 80px;
        padding: 4px 12px;
        background-color: #F9FAFC;

        .time {
          position: absolute;
          top: -24px;
          left: 0;
          font-size: 14px;
          font-weight: 500;
          color: #9E9E9E;
        }

        .team {
          height: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          div {
            overflow: hidden;
          }
        }
      }

      .left {
        position: absolute;
        left: -65px;
        top: -45px;
        display: flex;
        flex-flow: row;
        align-items: center;

        .prev-games {
          width: 40px;
          height: 175px;
          position: relative;

          .base {
            width: 20px;
            height: 54px;
            background-color: #F9FAFC;
            padding: 12px 10px 12px 10px;
            border-radius: 2px;
            border: 1px #E7E7EF solid;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            .logo {
              width: 18px;
              height: 18px;
              border-radius: 4px;
              overflow: hidden;
            }
          }

          .top {
            position: absolute;
            top: 0;
          }

          .bottom {
            position: absolute;
            bottom: 0;
          }
        }
      }

      .right {
        position: absolute;
        top: -100px;
        right: -65px;
        display: flex;
        flex-flow: row;
        align-items: center;

        .next {
          width: 20px;
          height: 54px;
          background-color: #F9FAFC;
          padding: 12px 10px 12px 10px;
          border-radius: 2px;
          border: 1px #E7E7EF solid;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;

          .logo {
            width: 18px;
            height: 18px;
            border-radius: 4px;
            overflow: hidden;
          }
        }
      }

      .right-gj {
        position: absolute;
        top: 50%;
        right: -65px;
        flex-flow: row;
        transform: translateY(-50%);
        box-sizing: border-box;
        width: 40px;
        height: 40px;
        background-color: #F9FAFC;
        border: 1px #E7E7EF solid;
        text-align: center;
        line-height: 40px;

        .line-gj {
          position: absolute;
          left: -26px;
          top: 50%;
          width: 25px;
          height: 2px;
          background-color: #000;
          z-index: 0;
        }

        img {
          width: 30px;
          height: 30px;
          margin-top: 3px;
        }
      }
    }

    .w1 {
      margin-bottom: 50px;
      width: 80%;
    }

    .w2 {
      margin-bottom: 110px;
      width: 60%;
    }

    .w3 {
      margin-bottom: 110px;
      width: 80%;
    }

    .w4 {
      width: 60%;
      margin-bottom: 110px;
    }
  }

  .size-left {
    width: 27px;
    height: 100px;
  }

  .size-right {
    width: 25px;
    height: 134px;
  }

  .height {
    height: 193px;
  }

  .line {
    position: relative;

    .line1 {
      position: absolute;
      top: 0;
      left: 2px;
      height: 2px;
      width: 13px;
      background-color: #191919;
    }

    .line2 {
      position: absolute;
      top: 100%;
      left: 2px;
      height: 2px;
      width: 13px;
      background-color: #191919;
    }

    .line3 {
      position: absolute;
      top: 0;
      left: 50%;
      height: 100%;
      width: 2px;
      background-color: #191919;
    }

    .line4 {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 2px;
      width: 13px;
      background-color: #191919;
    }
  }

  .marginLeft {
    margin-left: 20%;
  }
}</style>
